import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDto } from "../../types/user.dto";

interface UserState {
  users: UserDto[];
  isLoading: boolean;
}
const initialState: UserState = {
  users: [],
  isLoading: false,
};

export const userState = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<UserDto[]>) => {
      state.users = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsLoading, setUsers } = userState.actions;
export default userState.reducer;
